<template>
  <v-card v-if="mitigationHabitat" id="mitigation-habitat-form">
    <v-card-title class="primary white--text">
      <v-row class="pa-2" justify="space-between">
        <span class="headline">
          {{ title }}
        </span>
        <BaseDialogActions hideRefresh hideFullscreen />
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-text-field
      class="pt-4"
      v-model="mitigationHabitat.name"
      :rules="[rules.required]"
      :label="$t('habitatName')"
      :placeholder="$t('habitatNamePlaceholder')"
      color="black"
      :counter="maxNameLength"
      :maxlength="maxNameLength"
      ref="mitigationHabitatName"/>
      <v-textarea
      class="pt-2"
      v-model="mitigationHabitat.description"
      :label="$t('habitatDescription')"
      :placeholder="$t('habitatDescriptionPlaceholder')"
      color="black"
      rows="3"
      auto-grow
      :counter="maxDescriptionLength"
      :maxlength="maxDescriptionLength"/>
      <v-textarea
      class="pt-2"
      v-model="mitigationHabitat.mitigationSteps"
      :label="$t('mitigationSteps')"
      :placeholder="$t('habitatStepsPlaceholder')"
      color="black"
      rows="5"
      auto-grow
      :counter="maxStepsLength"
      :maxlength="maxStepsLength"/>
      <v-row no-gutters justify="end" class="mt-2">
        <v-btn id="mitigation-habitat-submit" color="primary" @click="submitClicked" :disabled="!canSubmit">
          {{ buttonText }}
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapActions } from 'vuex'
import fieldRules from '@/utils/rules.js'
import { StringConstants } from '@/utils/constants'

export default {
  name: 'MitigationHabitatForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    propMitigationHabitat: {
      type: Object,
      required: false,
      default: undefined
    }
  },

  created () {
    if (this.propMitigationHabitat) {
      this.mitigationHabitat = cloneDeep(this.propMitigationHabitat)
      this.mitigationHabitat.description = this.mitigationHabitat.description ?? ''
      this.mitigationHabitat.mitigationSteps = this.mitigationHabitat.mitigationSteps ?? ''
    }
  },

  mounted () {
    setTimeout(_ => {
      this.$refs.mitigationHabitatName.focus()
    }, 0)
  },

  computed: {
    editing () {
      return this.mitigationHabitat?.mitigationHabitatId
    },

    title () {
      return this.editing ? this.$t('editMitigationHabitat') : this.$t('addMitigationHabitat')
    },

    buttonText () {
      return this.editing ? this.$t('saveChanges') : this.$t('create')
    },

    canSubmit () {
      const name = this.mitigationHabitat.name.trim()
      return name.length > 0 && name.length <= this.maxNameLength
    }
  },

  data: () => ({
    mitigationHabitat: {
      name: '',
      description: '',
      mitigationSteps: ''
    },
    maxNameLength: StringConstants.LongStringLength,
    maxDescriptionLength: StringConstants.ExtraExtraLongStringLength,
    maxStepsLength: StringConstants.ExtraExtraLongStringLength,
    rules: fieldRules.rules
  }),

  methods: {
    ...mapActions('mitigation-habitat', ['createMitigationHabitat', 'updateMitigationHabitat']),

    async submitClicked () {
      if (!this.canSubmit) {
        this.setSnackError(this.$t('nameIsRequired'))
        return
      }

      const requestObj = cloneDeep(this.mitigationHabitat)
      requestObj.name = requestObj.name.trim()
      requestObj.description = (requestObj.description ?? '').trim() || null
      requestObj.mitigationSteps = (requestObj.mitigationSteps ?? '').trim() || null

      if (this.editing) {
        await this.updateMitigationHabitat(requestObj)
        this.setSnack(this.$t('mitigationHabitatUpdated'))
      } else {
        await this.createMitigationHabitat(requestObj)
        this.setSnack(this.$t('mitigationHabitatCreated'))
      }
      this.$emit('mitigation-habitat-mutated')
    }
  }
}
</script>
